/* This module is for the logo changes which described in task SAND-2718 */
define('shared/initializer/logoChanger',[
    '$',
    'shared/util/state',
    'shared/util/state/adapters/session',
    'shared/util/state/adapters/onChange',
    'shared/util/Domain',
    'shared/lib/console',
    'shared/lib/RSVP',
    'shared/lib/URI'
], function(
    $,
    state,
    sessionAdatper,
    onChangeAdapter,
    Domain,
    console,
    RSVP,
    URI
) {
    'use strict';

    var LOG_NAME = 'shared/initializer/logoChanger: ';
    var KEY_FROM_REMOTE = 'session.fromEnglishTownDomain';
    var promiseChanging = false;
    var isDone = false;

    function checkCondition() {
        var uri = new URI(document.referrer);
        var previousDomain = new Domain(uri.hostname());
        var currentDomain = new Domain(window.location.hostname);

        return state.adapters
            .add(sessionAdatper)
            .then(function(){
                if (
                    previousDomain.is.subOf(Domain.ENGLISHTOWN_SEO) ||
                    currentDomain.is.subOf(Domain.ENGLISHTOWN_SEO)
                ) {
                    return state.push(KEY_FROM_REMOTE, true);
                }
                else {
                    return state.adapters.add(onChangeAdapter)
                        .then(function(){
                            return state.get(KEY_FROM_REMOTE);
                        })
                        .then(function(values){
                            var fromEnglishTownDomain = values[0];
                            if (fromEnglishTownDomain === true) {
                                return RSVP.resolve();
                            }
                            else {
                                return new RSVP.Promise(function(resolve){
                                    function handler(key, value){
                                        if (key !== KEY_FROM_REMOTE || value !== true) {
                                            return;
                                        }

                                        resolve();
                                    }
                                    onChangeAdapter.on('change', handler);
                                    setTimeout(function(){
                                        onChangeAdapter.off('change', handler);
                                    }, 1000 * 60 * 3);
                                });
                            }
                        });
                }
            });
    }

    function swapLogo() {
        console.log(LOG_NAME, 'Trying to change logo to englishtown classic logo');

        var $logo = $('.logo-component img,' +
                'html.et-pagename-thankyou header img[title|=english-live-logo]');

        if ($logo.length <= 0) {
            return RSVP.resolve();
        }

        var promiseLogoLoaded;
        promiseLogoLoaded = new RSVP.Promise(function(resolve){
            if ($logo[0].complete) {
                resolve();
                return;
            }

            $logo.on('load', resolve);
        });

        return promiseLogoLoaded.then(function() {
            var height = $logo.height();
            var originalUrl = $logo.prop('src');
            var anchor = window.document.createElement('a');

            anchor.href = originalUrl;
            anchor.pathname = '/etc/designs/b2c/2013/imgs/logo/EnglishTown-Logo.png';
            $logo.prop('src', anchor.href);
            $logo.css({
                'width': 'auto',
                'height': height
            });

            console.log(LOG_NAME, 'Logo changed');

            return RSVP.resolve();
        });
    }

    function checkBeforeSwapLogo() {
        if (isDone) {
            return;
        }

        if (promiseChanging) {
            promiseChanging.then(function(){
                promiseChanging = null;
                checkBeforeSwapLogo();
            });
        }

        promiseChanging = checkCondition()
            .then(function(){
                return swapLogo()
                    .then(function(){
                        isDone = true;
                    });
            })
            .then(function(){
                promiseChanging = null;
            }, function(){
                promiseChanging = null;
            });
    }

    return {
        init: function(){
            checkBeforeSwapLogo();
        }
    };

});

